// extracted by mini-css-extract-plugin
module.exports = {"version-label":"ADmUQdjg-xqUbmzTCqahrw=="};